import Vue from 'vue';
import Vuex from 'vuex';
import firebase from '@/scripts/firebase';

firebase.init();
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuOpen: false,
    firebase: null,
    projects: {
      it: [],
      en: [],
    },
    homeProjects: {
      it: [],
      en: [],
    },
    lang: 'en',
  },
  mutations: {
    SET_DATA(state, payload) {
      state.firebase = payload;
      const childrens = Object.keys(payload.portfolio.childrens);
      childrens.forEach((key) => {
        const structure = payload.portfolio.childrens[key].structure[state.lang];
        const structureKeys = Object.keys(payload.portfolio.childrens[key].structure[state.lang]);
        const project = {};
        structureKeys.forEach((componentKey) => {
          if (structure[componentKey].component === 'ProjectHero') {
            project.isHome = structure[componentKey].data.isHome;
            project.title = structure[componentKey].data.title;
            project.cover = structure[componentKey].data.homeImage;
            project.text = structure[componentKey].data.homeDescription;
            project.link = `/${key}`;
            project.order = payload.portfolio.childrens[key].order;
          }
        });
        if (state.projects[state.lang].findIndex(
          projectToFind => projectToFind.title === project.title // eslint-disable-line
        ) === -1) state.projects[state.lang].push(project);
        if (project.isHome) {
          if (state.homeProjects[state.lang].findIndex(
            projectHomeToFind => projectHomeToFind.title === project.title // eslint-disable-line
          ) === -1) state.homeProjects[state.lang].push(project);
        }
      });

      state.projects[state.lang].sort((a, b) => a.order - b.order);
      state.homeProjects[state.lang].sort((a, b) => a.order - b.order);
    },

    SET_SETTINGS(state, payload) {
      state.settings = payload;
    },

    SET_LANG(state, payload) {
      state.lang = payload;
    },
  },
  actions: {
    async LOAD_DATA(context) {
      if (firebase.database === null) firebase.init();
      const data = firebase.loadData();
      const settings = firebase.loadSettings();
      const results = await Promise.all([data, settings]);
      context.commit('SET_DATA', results[0]);
      context.commit('SET_SETTINGS', results[1]);
    },
  },
});
